import React, { createContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!sessionStorage.getItem("token"));
  const [authToken, setAuthToken] = useState(sessionStorage.getItem("token"));
  const [userRole, setUserRole] = useState(sessionStorage.getItem("userRole") || null);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const role = sessionStorage.getItem("userRole");
    setIsAuthenticated(!!token);
    setAuthToken(token);
    setUserRole(role);
  }, []);

  const login = (token, role) => {
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("userRole", role);
    setAuthToken(token);
    setUserRole(role);
    setIsAuthenticated(true);
  };

  const logout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userRole");
    setIsAuthenticated(false);
    setAuthToken(null);
    setUserRole(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, authToken, userRole, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
